import Footer from '@seller-hermes/features/login/Footer';
import FullLogo from '@seller-hermes/features/login/FullLogo';
import { Loader2 } from 'lucide-react';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useTitle } from 'react-use';
import {
  Container,
  ModalContainerWrapper,
} from '@seller-hermes/features/login/login.styles';

export const UnloggedPageLayout = () => {
  useTitle('Login | Abbiamo');
  return (
    <ModalContainerWrapper>
      <FullLogo />
      <Container>
        <Suspense
          fallback={
            <div className="flex w-full items-center justify-center py-10">
              <Loader2 className="text-muted-foreground h-6 w-6 animate-spin" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </Container>
      <Footer />
    </ModalContainerWrapper>
  );
};
